import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import { FaCheckCircle, FaCopy } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import AlertMessage from "components/AlertMessage/AlertMessage";

const WebhookSuccessDialog = ({ open, onClose, webhook }) => {
  const [copied, setCopied] = useState(false);

  if (!webhook) return null;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(webhook.url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <VuiBox p={3}>
        <VuiBox display="flex" alignItems="center" gap={1}>
          <FaCheckCircle size={18} />
          <VuiTypography variant="lg">Integration Activated</VuiTypography>
        </VuiBox>

        <Divider sx={{ my: 0.7 }} />

        <VuiTypography variant="caption" mb={1.5}>
          Webhook URL
        </VuiTypography>

        <VuiBox display="flex" gap={1}>
          <VuiBox
            flex={1}
            px={1.5}
            py={0.8}
            borderRadius="8px"
            sx={{
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.1)",
              wordBreak: "break-all",
              display: "flex",
              alignItems: "center",
              minHeight: 36,
            }}
          >
            <VuiTypography variant="caption">{webhook.url}</VuiTypography>
          </VuiBox>

          <VuiButton variant="outlined" onClick={handleCopy}>
            <FaCopy size={12} />
          </VuiButton>
        </VuiBox>

        {copied && (
          <VuiBox>
            <VuiTypography
              variant="caption"
              sx={{
                color: "#4fd1c5",
                mt: 0.8,
                fontSize: "11px",
                opacity: 0.9,
              }}
            >
              ✓ Webhook URL copied to clipboard
            </VuiTypography>
          </VuiBox>
        )}

        {webhook.events?.length > 0 && (
          <>
            <VuiTypography variant="caption" mt={3}>
              Subscribed Events
            </VuiTypography>

            <VuiBox>
              {webhook.events.map((event, index) => (
                <VuiTypography key={index} variant="caption" px={0.5}>
                  • {event}
                </VuiTypography>
              ))}
            </VuiBox>
          </>
        )}

        <VuiBox display="flex" justifyContent="flex-end" mt={3}>
          <VuiButton color="primary" onClick={onClose}>
            Done
          </VuiButton>
        </VuiBox>
      </VuiBox>
    </Dialog>
  );
};

export default WebhookSuccessDialog;
